import debounce from 'lodash-es/debounce';
import $ from 'jquery';

export default function init() {
    controlIllustrationVideoPlaying();

    $(window).on('scroll', function() {
      controlIllustrationVideoPlaying();
    });

    $(window).on('resize', debounce(function() {
      adjustFullsizeVideos();
    }, 500));

    $(window).on('load', function() {
      adjustFullsizeVideos();
    });
}
function controlIllustrationVideoPlaying() {
  var scrollTop = $(window).scrollTop();
  var viewportHeight = $(window).height();

  $(".js-illustration-video").each(function() {
    var fromTop = $(this).offset().top;
    var videoHeight = $(this).height();

    // video is visible in viewport
    if(((scrollTop + viewportHeight) > fromTop) &&  (scrollTop < (fromTop + videoHeight))) {
      $(this).get(0).play();
    } else {
      $(this).get(0).pause();
    }
  });
}

/**
 * Adjust fullsize videos, which take full width and height of outer container element.
*/
function adjustFullsizeVideos() {
  $(".js-fullsize-video").each(function() {
    var videoHeight = $(this).height();
    var videoWidth = $(this).width();
    var videoAspectRatio = videoWidth / videoHeight;

    var containerHeight = $(this).parent().outerHeight();
    var containerWidth = $(this).parent().outerWidth();
    var containerAspectRatio = containerWidth / containerHeight;

    if(videoAspectRatio > containerAspectRatio) {
      $(this).css("height", "100%");
      $(this).css("width", "auto");
    } else {
      $(this).css("height", "auto");
      $(this).css("width", "100%");
    }

    if (videoWidth > containerWidth) {
      var videoOutsideContainer = videoWidth - containerWidth;
      $(this).css("margin-left", "-" + videoOutsideContainer / 2 + "px");
    }
  });
}
